import { useSnapshot } from 'valtio';

import BookmarkIcon from '@cartwhl/ui/icons/BookmarkIcon';
import TrashIcon from '@cartwhl/ui/icons/TrashIcon';
import Button from '@cartwhl/ui/input/Button';

import { useStore, useStoreApi } from '../assetLibraryStore';
import { useAssetLibraryAssetActions } from '../hooks/useAssetLibraryAssetActions';
import AssetLibraryBlockedActionTooltip from './AssetLibraryTrashActionTooltip';

export default function AssetLibraryViewNavButtons({
  compact = false,
}: {
  compact?: boolean;
}) {
  const store = useStore();
  const storeApi = useStoreApi();
  const { selectedAssetCount } = useSnapshot(storeApi.state);
  const { bookmarkAllSelected, requestMoveToTrash, canDeleteAllAssets } =
    useAssetLibraryAssetActions();
  const hasSelection = selectedAssetCount > 0;
  const selectedAssets = hasSelection ? store.getSelectedDisplayAssets() : [];
  const moveAllToTrashDisabled =
    hasSelection && !canDeleteAllAssets(selectedAssets);
  const buttonSize = compact ? 'sm' : 'lg';

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button
        type="button"
        variant="secondary"
        size={buttonSize}
        icon={<BookmarkIcon />}
        alignIcon="end"
        onClick={() => {
          if (hasSelection) {
            void bookmarkAllSelected();
            return;
          }

          store.setLibraryView('bookmarks');
        }}
      >
        {hasSelection ? 'Bookmark all' : 'My Bookmarks'}
      </Button>
      <AssetLibraryBlockedActionTooltip disabled={moveAllToTrashDisabled}>
        <Button
          type="button"
          disabled={moveAllToTrashDisabled}
          variant={hasSelection ? 'secondary-destructive' : 'secondary'}
          size={buttonSize}
          icon={<TrashIcon className="size-4" />}
          alignIcon="end"
          onClick={() => {
            if (moveAllToTrashDisabled) {
              return;
            }

            if (hasSelection) {
              requestMoveToTrash(store.getSelectedDisplayAssets());
              return;
            }

            store.setLibraryView('trash');
          }}
        >
          {hasSelection ? 'Move all to Trash' : 'View Trash'}
        </Button>
      </AssetLibraryBlockedActionTooltip>
    </div>
  );
}
